export enum RapprochementFactureExterneStatutEnum {
  NON_RAPPROCHE = 'NON_RAPPROCHE',
  RAPPROCHEMENT_OK = 'RAPPROCHEMENT_OK',
  ECART = 'ECART',
  ECART_VALIDE = 'ECART_VALIDE',
  BL_MANQUANT = 'BL_MANQUANT',
  FOURNISSEUR_INTROUVABLE = 'FOURNISSEUR_INTROUVABLE'
}

export const RAPPROCHEMENT_FACTURE_EXTERNE_STATUT_LABELS: Record<RapprochementFactureExterneStatutEnum, string> = {
  [RapprochementFactureExterneStatutEnum.NON_RAPPROCHE]:          'Non rapproché',
  [RapprochementFactureExterneStatutEnum.RAPPROCHEMENT_OK]:       'Rapprochement OK',
  [RapprochementFactureExterneStatutEnum.ECART]:                  'Écart',
  [RapprochementFactureExterneStatutEnum.ECART_VALIDE]:           'Écart validé',
  [RapprochementFactureExterneStatutEnum.BL_MANQUANT]:            'BL manquant',
  [RapprochementFactureExterneStatutEnum.FOURNISSEUR_INTROUVABLE]:'Fournisseur introuvable',
};
